const app = {
    state: {
        cart_popup: false,
        cart_data: {},
        cart_type: false,
    	active:1,
        nav_type: null,
        footer: 0,
        crumbs: [],
        formData: {},
        indexImg: undefined,
        listsImg: [],
        paramImg: {
	      name: 'headimg',
	      detail: 'username'
        },
        num: 0,
        vip_popup: false,
        vip_phone: '',
        is_repay: 0,
        is_show: true,
        is_show1: true,
        img: '/static/images/img.png',
        headimg: '/static/images/headimg.png'
    },
    mutations: {
        NAV_TYPE: (state, value) => {
            state.nav_type = value
        },
        BG_WHITE: (state, type) => {
            if(type){
            
                // document.getElementsByTagName('html')[0].style.background = '#fff'
                document.body.style.background = '#fff'
            }else{
                // document.getElementsByTagName('html')[0].style.background = '#F7F7F7'
                document.body.style.background = '#f8f8f8'
            }
        },
        GET_CART_NUM(state) {
            let that = this;

            tools.ajax({
                url: '/api/gallery/designer/cart/num',
                ajaxData: {},
                successFun: function (res) {
                    state.num = res.data.num;
                },
                errorFun: function (error_data, status, headers, error_obj) {
                    tools.alert.error(error_data.error_msg);
                },
                type: 'GET'
            });
        },
    },
    actions: {
        navType({ commit }, value) {
            commit('NAV_TYPE', value)
        },
        bgWhite({ commit }, type) {
            commit('GET_INFO', type)
        },
        getCartNum({ commit }, type) {
            commit('GET_CART_NUM')
        },
    }
}

export default app


// WEBPACK FOOTER //
// ./src/store/modules/app.js